"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.substituteInvitationMetadataSchema = exports.invitationStatusSchema = exports.invitationStatuses = exports.invitationTypeSchema = exports.invitationTypes = void 0;
const zod_1 = require("zod");
exports.invitationTypes = [
    'doctor_substitute_join',
    'doctor_attending_join',
];
exports.invitationTypeSchema = zod_1.z.enum(exports.invitationTypes);
exports.invitationStatuses = [
    'pending',
    'confirmed',
    'declined',
    'canceled',
];
exports.invitationStatusSchema = zod_1.z.enum(exports.invitationStatuses);
exports.substituteInvitationMetadataSchema = zod_1.z.object({
    slotIds: zod_1.z.array(zod_1.z.string()).optional(),
    /** @deprecated use slotIds instead */
    slotId: zod_1.z.string().optional(),
    firstName: zod_1.z.string().optional(),
    lastName: zod_1.z.string().optional(),
    sites: zod_1.z.array(zod_1.z.object({ siteId: zod_1.z.string() }).passthrough()).optional(),
});
